import { usePurchaseFormState } from '@/entities/purchase-form';

// Using 'cartSubmitError' instead of React Hook Form's convention 'serverError' allows us to handle the full range of API errors (4xx/5xx) in one consistent place.
const CART_SUBMIT_ERROR_KEY = 'cartSubmitError';
export const ROOT_CART_SUBMIT_ERROR_KEY = `root.${CART_SUBMIT_ERROR_KEY}`;

export const useHasOnlyCartSubmitError = () => {
    const { errors } = usePurchaseFormState();

    const { root, ...fieldErrors } = errors;

    const hasOnlyCartSubmitError = Boolean(root?.[CART_SUBMIT_ERROR_KEY] && !Object.keys(fieldErrors).length);

    return { hasOnlyCartSubmitError };
};
